import { ColorScheme } from '@adornis/chemistry/elements/theming/coloring-system';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design';
import type { SpacingType } from '@adornis/chemistry/elements/theming/spacings';

export const FPSColors = {
  identityRed: '#fa0050',
  naturalSand: '#e6c896',
  energyYellow: '#ffff00',
  humanGreen: '#00ff96',
  lightBlue: '#00ffff',
  digitalBlue: '#0000ff',
  deepPurple: '#5a003c',
  resposibleGreen: '#002d37',
  basicBlue: '#00005a',
  pureBlack: '#000000',
} as const;

const defaultDesign = DesignSystem.currentTheme.getValue();
DesignSystem.prefix = 'fps';
DesignSystem.setTheme('fps', {
  ...defaultDesign,

  baseFontSize: 20,
  baseFontSizePrint: 20,
  borders: defaultDesign.borders,
  colors: new ColorScheme({
    ...defaultDesign.colors,

    accent: FPSColors.identityRed,
    primary: FPSColors.identityRed,
    tone: {
      subtle: FPSColors.naturalSand,
      warning: FPSColors.energyYellow,
      error: FPSColors.identityRed,
      success: FPSColors.humanGreen,
      placeholder: FPSColors.naturalSand,
    },
  }),
  spacing: {
    ...defaultDesign.spacing,
    md: '16px' as SpacingType,
  },
  sizes: {
    ...defaultDesign.sizes,
    borderRadius: '0px',
    border: '2px solid',
  },
});
DesignSystem.useTheme('fps');
